export const trainingSteps = [
  { displayName: 'Videos', routeName: 'videos' },
  { displayName: 'Quiz', routeName: 'quiz' },
  { displayName: 'Calls', routeName: 'calls' },
  { displayName: 'CRM', routeName: 'crm' },
  { displayName: 'Begin', routeName: 'complete' },
];

export const externalIds = {
    youtubePlaylist: 'PLrinyDyRpJyVbuG40VrxFmFwOBCqU1R8p',
    jotformQuiz: '251543943185057',
    jotformCall: '251553597853065',
    youtubeCall: 'dS-4W-nKPpg',
    youtubeCRM: 'PvUHQIdhxLw',
    youtubeComplete: 'E5UUebxx_6w'
};

export const externalEndpoints = {
  googlePlacesWorker: 'https://agent-training-places.yoav-4e1.workers.dev',
  zapierWebhook: 'https://hooks.zapier.com/hooks/catch/20055466/2vxqp3i/',
  closeReferralLink: 'https://refer.close.com/h5nx7eols2ku',
  closeLeadsWorker: 'https://close-crm-add-leads.yoav-4e1.workers.dev/',
}